import styled, { css } from 'styled-components';
import {
  mq,
  getGridSpans,
  getTransition,
  setGridColumns,
  gridContainer,
  px2rem
} from '../../../stylesheets/tools';

const transitionDots = '/static/dots/footer-background.svg';

export const StyledEventSlider = styled.div`
  .event-slider__top-dots,
  .event-slider__bottom-dots {
    position: relative;
    width: 100%;
    height: 327px;
    mask-size: 444px 327px;
    background-color: ${props => props.theme.siteTheme.secondary};
    mask-image: url(${transitionDots});
    mask-repeat: repeat;
    z-index: -1;

    ${mq('m')} {
      height: 436px;
      mask-size: 592px 436px;
    }
  }

  .event-slider__top-dots {
    margin-bottom: -5px;
  }

  .event-slider__bottom-dots {
    margin-top: -5px;
    transform: rotate(180deg);
  }

  .event-slider__content {
    background-color: ${props => props.theme.siteTheme.secondary};

    .event-slider__carousel {
      margin-right: auto;
      margin-top: 30px;

      ${mq('l')} {
        margin-top: 45px;
      }

      .event-slider__more {
        display: flex;
        align-items: center;
        padding-left: 30px;

        .event-slider__more-link {
          font-size: 16px;
          text-transform: uppercase;
          display: flex;
          gap: 15px;
          flex-direction: column;
        }
      }
    }
  }

  .slider__controls {
    position: unset;
    margin-top: -10px;

    ${mq('l')} {
      margin-top: -25px;
    }
  }

  .swiper-container {
    display: block;
    margin: 0 auto;
    position: relative;
    list-style: none;
    padding: 0;
    opacity: 0;
    ${getTransition()}

    ${props =>
      props.isInit &&
      css`
        opacity: 1;
      `}
  }

  .swiper-wrapper {
    ${getGridSpans('margin-left', { s: [1, 'spread'], l: [2, 'spread'] })}
    position: relative;
    z-index: 5;
    width: 100%;
    height: auto;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-slide {
    height: auto;
    width: auto;
    flex-shrink: 0;
    position: relative;
    ${getTransition()}
    display: inline-flex;

    .slider__image-wrapper {
      height: 100%;
    }

    &:not(.swiper-slide-active):not(.event-slider__more) {
      transform: scale(0.84);
      transform-origin: top right;
    }

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
  }

  .swiper-container-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }

  .swiper-container-no-flexbox .swiper-slide {
    float: left;
  }

  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
`;

export const StyledEventSliderSkeleton = styled.div`
  background-color: #f8f8f8;
  padding: ${px2rem('60px')} 0;

  ${mq('l')} {
    padding: ${px2rem('80px')} 0;
  }

  .skeleton__headline {
    height: ${px2rem('40px')};
    max-width: ${px2rem('260px')};
    width: 100%;
    background-color: #ececec;
    margin-bottom: ${px2rem('60px')};
  }

  .skeleton-wrapper {
    margin-bottom: ${px2rem('-25px')};
    padding-left: ${px2rem('60px')};

    ${mq('l')} {
      grid-gap: ${px2rem('16')};
    }
    ${gridContainer()}
    ${setGridColumns('1fr', 1, {
      m: ['1fr', 3],
      l: ['1fr', 4]
    })}

    .skeleton-wrapper__item {
      height: ${px2rem('360px')};
      width: 100%;
      background-color: #e3e3e3;

      &:not(:first-child) {
        display: none;
      }

      ${mq('m')} {
        &:not(:first-child) {
          transform: scale(0.84);
          transform-origin: top right;
          display: block;
        }
        &:last-child {
          display: none;
        }
      }

      ${mq('l')} {
        &:last-child {
          display: block;
        }
      }
    }
  }
`;
